import { SxProps, Theme } from "@mui/material";

// New: Container for the whole update details page
export const pageContainer: SxProps<Theme> = {
  mx: "auto",
  my: { xs: 0, lg: 3 },
  px: 2,
  maxWidth: 1600,
};

// New: Layout for sidebar and content
export const bodyLayout: SxProps<Theme> = {
  mt: 2,
  display: "flex",
  flexDirection: { xs: "column", lg: "row" },
  gap: 3,
};

// New: Sidebar container
export const sidebarContainer: SxProps<Theme> = {
  flex: "0 0 260px",
};

// New: Sidebar inner box
export const sidebarInner: SxProps<Theme> = {
  borderRadius: 2,
  bgcolor: "white",
  p: 2,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const sidebarButton = (active: boolean): SxProps<Theme> => ({
  borderRadius: 2,
  fontWeight: 700,
  textTransform: "none",
  bgcolor: active ? "#29464e" : "white",
  color: active ? "white" : "#29464e",
  borderColor: "#29464e",
  "&:hover": {
    bgcolor: active ? "#18313a" : "#f0f4f5",
  },
});

// New: Content container
export const contentContainer: SxProps<Theme> = {
  flex: "1 1 auto",
};

export const formContainer: SxProps<Theme> = {
  borderRadius: 2,
  bgcolor: "white",
  p: 3,
  minHeight: 500,
};

// New: Section title style
export const sectionTitle: SxProps<Theme> = {
  pt: 2.5,
  px: 3,
};

// New: Form inner padding
export const formInner: SxProps<Theme> = {
  p: 3,
};

// Add more shared styles as needed...
